import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";

export default function KickboxingLanding() {
  const [expanded, setExpanded] = useState(false);
  return (
    <Navbar
      bg="dark"
      variant="dark"
      expand="lg"
      className="fixed-top text-white"
      expanded={expanded}
      onToggle={setExpanded}
    >
      <Container>
        <Navbar.Brand>
          <Link to="/" className="navbar-brand fw-bold">
            LONDON <span className="text-danger">KICKBOXING</span>
          </Link>
        </Navbar.Brand>

        {/* Toggle button (hamburger) */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        {/* Collapsible content */}
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Link
              to="/"
              className="nav-link"
              onClick={() => setExpanded(false)}
            >
              Home
            </Link>
            <Link
              to="about"
              className="nav-link"
              onClick={() => setExpanded(false)}
            >
              About Us
            </Link>
            <Link
              to="classes"
              className="nav-link"
              onClick={() => setExpanded(false)}
            >
              Classes
            </Link>
            <Link
              to="children"
              className="nav-link"
              onClick={() => setExpanded(false)}
            >
              Children
            </Link>
            <Link
              to="personal_training"
              className="nav-link"
              onClick={() => setExpanded(false)}
            >
              Personal Training
            </Link>
            <Link
              to="self_defence"
              className="nav-link"
              onClick={() => setExpanded(false)}
            >
              Self Defence
            </Link>
            {/* Dropdown */}
            <NavDropdown title="More" id="more-dropdown">
              <NavDropdown.Item>
                <Link to="courses" onClick={() => setExpanded(false)}>
                  {" "}
                  Courses
                </Link>
              </NavDropdown.Item>
              <NavDropdown.Item>
                <Link to="friends" onClick={() => setExpanded(false)}>
                  {" "}
                  Friends
                </Link>
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item>
                <Link to="faqs" onClick={() => setExpanded(false)}>
                  {" "}
                  FAQs
                </Link>
              </NavDropdown.Item>
            </NavDropdown>
            <Link
              to="memberships"
              className="nav-link"
              onClick={() => setExpanded(false)}
            >
              Memberships
            </Link>
            <Link
              to="contacts"
              className="nav-link"
              onClick={() => setExpanded(false)}
            >
              Contact Us
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>

    // <nav className="navbar navbar-expand-lg fixed-top navbar-dark bg-black px-4">
    //   <Link to="/" className="navbar-brand fw-bold">
    //     LONDON <span className="text-danger">KICKBOXING</span>
    //   </Link>
    //   <button
    //     className="navbar-toggler"
    //     type="button"
    //     data-bs-toggle="collapse"
    //     data-bs-target="#navbarNav"
    //   >
    //     <span className="navbar-toggler-icon"></span>
    //   </button>
    //   <div
    //     className="collapse navbar-collapse justify-content-end" id="navbarNav">
    //     <ul className="navbar-nav me-3">
    //       <li className="nav-item">
    //         <Link
    //           to="about"
    //           className="nav-link"
    //           title="londonkickboxing about us page"
    //         >
    //           About Us
    //         </Link>
    //       </li>
    //       <li className="nav-item">
    //         <Link
    //           to="classes"
    //           className="nav-link"
    //           title="londonkickboxing classes page"
    //         >
    //           Classes
    //         </Link>
    //       </li>
    //       <li className="nav-item">
    //         <Link
    //           to="children"
    //           className="nav-link"
    //           title="londonkickboxing children page"
    //         >
    //           Children
    //         </Link>
    //       </li>
    //       <li className="nav-item">
    //         <Link
    //           to="personal_training"
    //           className="nav-link"
    //           title="londonkickboxing personal training page"
    //         >
    //           Personal Training
    //         </Link>
    //       </li>
    //       <li className="nav-item">
    //         <Link
    //           to="self_defence"
    //           className="nav-link"
    //           title="londonkickboxing self defence page"
    //         >
    //           Self Defence
    //         </Link>
    //       </li>
    //       <li className="nav-item">
    //         <Link
    //           to="memberships"
    //           className="nav-link"
    //           title="londonkickboxing memberships page"
    //         >
    //           Memberships
    //         </Link>
    //       </li>
    //       <li className="nav-item">
    //         <Link
    //           to="contacts"
    //           className="nav-link"
    //           title="londonkickboxing contact page"
    //         >
    //           Contact Us
    //         </Link>
    //       </li>
    //     </ul>
    //     {/* <button className="btn btn-danger">Book a Free Trial</button> */}
    //   </div>
    // </nav>
  );
}
